import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import {
  CustomAppDialog,
  CustomDialogCloseButton,
} from "../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { MdDelete } from "react-icons/md";
import IconButton from "../../components/common/IconButton";

import FormSelectionField from "../../components/formFields/FormSelectionField";
import { IItem } from "../item/itemModel";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { APPROVAL_TYPE } from "../../_contstants/common";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import { deleteBandhaiReceiptApprovalItem } from "./services/bandhaiReceipt.services";
import {
  closeBandhaiReceiptApprovalItemDeleteConfirmDialog,
  openBandhaiReceiptApprovalItemDeleteConfirmDialog,
  setBandhaiReceiptApprovalItemIndex,
} from "./bandhaiReceiptSlice";
import { findAllActiveItem } from "../item/services/item.services";
import FormDatePicker from "../../components/formFields/FormDateField";

const BandhaiReceiptApprovalItemsArray = (
  fieldArrayRenderProps: FieldArrayRenderProps
) => {
  const dispatch = useAppDispatch();
  const BandhaiReceiptApprovalItemIndex = useAppSelector(
    (state) => state.bandhaireceipt.BandhaiReceiptApprovalItemIndex
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const isViewDialog = dialogName.startsWith("view-bandhai-approval-items-");
  const BandhaiReceiptApprovalItemDeleteConfirmDialog = useAppSelector(
    (state) =>
      state.bandhaireceipt.BandhaiReceiptApprovalItemDeleteConfirmDialog
  );

  const fieldName = fieldArrayRenderProps.name;
  const ItemList = useAppSelector((state) => state.item.ItemList);
  const UnitList = useAppSelector((state) => state.unit.UnitList);

  const handleDeleteAction = React.useCallback(
    async (index: any) => {
      if (fieldArrayRenderProps?.value[index]?.id) {
        const response = await dispatch(
          deleteBandhaiReceiptApprovalItem(
            fieldArrayRenderProps?.value[index].id
          )
        );
        if (response.meta.requestStatus === "fulfilled") {
          fieldArrayRenderProps.onRemove({ index: index });
          dispatch(closeBandhaiReceiptApprovalItemDeleteConfirmDialog());
          dispatch(setBandhaiReceiptApprovalItemIndex(-1));
        }
      } else {
        fieldArrayRenderProps.onRemove({ index: index });
        dispatch(closeBandhaiReceiptApprovalItemDeleteConfirmDialog());
        dispatch(setBandhaiReceiptApprovalItemIndex(-1));
      }
    },
    [fieldArrayRenderProps]
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps?.onPush({
      value: {
        IssueDate: new Date(),
        type: "",
        item_id: null,
        weight: null,
        qty: null,
        unit_id: null,
        return_weight: null,
        return_qty: null,
        used_weight: null,
        used_qty: null,
        customer_rate: null,
        customer_less_weight: null,
      },
    });
  }, [fieldArrayRenderProps]);

  const handleOpenDeleteDialog = (index: any) => {
    dispatch(openBandhaiReceiptApprovalItemDeleteConfirmDialog());
    dispatch(setBandhaiReceiptApprovalItemIndex(index));
  };

  // const handleOpenEditOrderDialog = (index: any) => {
  //   dispatch(openDialog("show-ghat-items-dialog"));
  //   dispatch(setOpenOrderItemIndex(index));
  // };
  // const handleOrderView = async (itemID: any, OrderID: any) => {
  //   const payload = {
  //     process_id: PROCESS_ID.ghat,
  //     item_id: itemID,
  //   };
  //   if (itemID && OrderID) {
  //     await dispatch(findProductImageByProcess(payload));
  //     await dispatch(findbyOrderNo(OrderID));
  //     dispatch(openDialog("viewOrderDialog"));
  //   }
  // };

  return (
    <>
      <CustomAppDialog open={BandhaiReceiptApprovalItemDeleteConfirmDialog}>
        <>
          <Typography.h5>{"Delete Approval Items Item"}</Typography.h5>
          <GridLayout>
            <GridLayoutItem>
              <Typography.p>Are you sure you want to delete this?</Typography.p>
            </GridLayoutItem>
            <GridLayoutItem
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <CustomDialogCloseButton
                themeColor="error"
                closeDialogFunction={
                  closeBandhaiReceiptApprovalItemDeleteConfirmDialog
                }
              />
              <Button
                fillMode={"solid"}
                themeColor={"error"}
                onClick={() =>
                  handleDeleteAction(BandhaiReceiptApprovalItemIndex)
                }
                type="button"
              >
                Delete
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </>
      </CustomAppDialog>
      <GridLayout cols={[{ width: "50%" }, { width: "50%" }]}>
        <GridLayoutItem>
          <Typography.h5 style={{ marginBottom: 5 }}>
            Approval Items
          </Typography.h5>
        </GridLayoutItem>
        <GridLayoutItem style={{ textAlign: "left", marginLeft: "auto" }}>
          {!isViewDialog && (
            <Button
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={pushElementInarray}
              type="button"
            >
              Add Item
            </Button>
          )}
        </GridLayoutItem>
      </GridLayout>
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 && (
          <div
            className="table-responsive"
            style={{
              maxHeight: isViewDialog ? "50vh" : "20vh",
              scrollbarWidth: "thin",
              marginTop: 10,
            }}
          >
            <table
              className="table table-striped table-bordered table-hover field-array-table"
              style={{ minWidth: 2200 }}
            >
              <thead>
                <tr>
                  <th style={{ width: "7%" }}>Issue Date</th>
                  <th style={{ width: "6%" }}>Type</th>
                  <th style={{ width: "11%" }}>Product Name</th>

                  <th style={{ width: "8%" }}>Issue Weight (gm)</th>
                  <th style={{ width: "6%" }}>Issue Qty</th>
                  <th style={{ width: "6%" }}>Unit</th>

                  <th style={{ width: "8%" }}>Return Weight (gm)</th>
                  <th style={{ width: "8%" }}>Return Qty</th>

                  <th style={{ width: "8%" }}>Used Weight (gm)</th>
                  <th style={{ width: "9%" }}>Used Qty</th>

                  <th style={{ width: "7%" }}>Customer Rate</th>
                  <th style={{ width: "9%" }}>Customer Less Weight (gm)</th>

                  <th
                    style={{
                      width: "3%",
                      position: "sticky",
                      right: 0,
                      zIndex: 10,
                      background: "#2c3e50",
                    }}
                  ></th>
                </tr>
              </thead>
              <tbody>
                {fieldArrayRenderProps.value &&
                  fieldArrayRenderProps.value.length > 0 &&
                  fieldArrayRenderProps.value.map(
                    (approval_items: any, index: number) => (
                      <tr>
                        <td>
                          <Field
                            name={`${fieldName}.${index}.IssueDate`}
                            component={FormDatePicker}
                            validator={requiredValidator}
                          />
                        </td>
                        <td>
                          <Field
                            name={`${fieldName}.${index}.type`}
                            wrapperStyle={{ margin: 0 }}
                            placeholder="Select Type"
                            component={FormSelectionField}
                            options={APPROVAL_TYPE?.map((type: any) => {
                              return {
                                value: type.value,
                                label: type.label,
                              };
                            })}
                            validator={requiredValidator}
                            disabled={isViewDialog}
                          />
                        </td>
                        <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.item_id`}
                            isAddNew={true}
                            addNewLink="item/create"
                            dispatcherFunction={findAllActiveItem}
                            placeholder="Select Item"
                            component={FormSelectionField}
                            validator={requiredValidator}
                            disabled={isViewDialog}
                            options={ItemList?.map((item: IItem) => {
                              return {
                                value: item.id,
                                label: item.item_name,
                              };
                            })}
                          />
                        </td>
                        <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.weight`}
                            placeholder="0.000"
                            type="number"
                            format="n3"
                            component={FormNumericTextField}
                            validator={requiredValidator}
                            disabled={isViewDialog}
                          />
                        </td>
                        <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.qty`}
                            placeholder="0.00"
                            type="number"
                            format="n2"
                            component={FormNumericTextField}
                            validator={requiredValidator}
                            disabled={isViewDialog}
                          />
                        </td>
                        <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.unit_id`}
                            placeholder="Select Unit"
                            component={FormSelectionField}
                            validator={requiredValidator}
                            disabled={isViewDialog}
                            options={UnitList?.map((unit: any) => {
                              return {
                                value: unit.id,
                                label: unit.unit_name,
                              };
                            })}
                          />
                        </td>
                        <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.return_weight`}
                            placeholder="0.00"
                            type="number"
                            format="n3"
                            component={FormNumericTextField}
                            disabled={
                              fieldArrayRenderProps.formRenderProps.valueGetter(
                                `${fieldName}.${index}.type`
                              ) === "SAMPLE"
                                ? true
                                : false
                            }
                          />
                        </td>
                        <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.return_qty`}
                            placeholder="0.00"
                            type="number"
                            format="n3"
                            component={FormNumericTextField}
                            disabled={
                              fieldArrayRenderProps.formRenderProps.valueGetter(
                                `${fieldName}.${index}.type`
                              ) === "SAMPLE"
                                ? true
                                : false
                            }
                          />
                        </td>
                        <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.used_weight`}
                            placeholder="0.00"
                            type="number"
                            format="n3"
                            disabled={
                              fieldArrayRenderProps.formRenderProps.valueGetter(
                                `${fieldName}.${index}.type`
                              ) === "SAMPLE"
                                ? true
                                : false
                            }
                            component={FormNumericTextField}
                          />
                        </td>
                        <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.used_qty`}
                            placeholder="0.00"
                            type="number"
                            format="n3"
                            disabled={
                              fieldArrayRenderProps.formRenderProps.valueGetter(
                                `${fieldName}.${index}.type`
                              ) === "SAMPLE"
                                ? true
                                : false
                            }
                            component={FormNumericTextField}
                          />
                        </td>
                        {/* <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.balance_weight`}
                            placeholder="0.00"
                            type="number"
                            format="n3"
                            component={FormNumericTextField}
                            disabled={
                              fieldArrayRenderProps.formRenderProps.valueGetter(
                                `${fieldName}.${index}.type`
                              ) === "SAMPLE"
                                ? true
                                : false
                            }
                          />
                        </td> */}
                        <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.customer_rate`}
                            placeholder="0.00"
                            type="number"
                            format="n3"
                            component={FormNumericTextField}
                            // validator={requiredValidator}
                            disabled={
                              fieldArrayRenderProps.formRenderProps.valueGetter(
                                `${fieldName}.${index}.type`
                              ) === "SAMPLE"
                                ? true
                                : false
                            }
                          />
                        </td>
                        <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.customer_less_weight`}
                            placeholder="0.00"
                            type="number"
                            format="n3"
                            component={FormNumericTextField}
                            // validator={requiredValidator}
                            disabled={
                              fieldArrayRenderProps.formRenderProps.valueGetter(
                                `${fieldName}.${index}.type`
                              ) === "SAMPLE"
                                ? true
                                : false
                            }
                          />
                        </td>
                        <td
                          style={{
                            position: "sticky",
                            right: 0,
                            zIndex: 2,
                            backgroundColor: "white",
                          }}
                        >
                          <IconButton
                            type="button"
                            fillMode="solid"
                            size="small"
                            title="Delete"
                            themeColor="error"
                            onClick={() => handleOpenDeleteDialog(index)}
                            style={{
                              position: "absolute",
                              height: 32,
                              width: 32,
                              right: 15,
                              pointerEvents: "all",
                            }}
                          >
                            <MdDelete
                              className="absolute-position"
                              style={{ fontSize: "22px" }}
                            />
                          </IconButton>
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>
          </div>
        )}
    </>
  );
};

export default BandhaiReceiptApprovalItemsArray;
